module.exports = __webpack_public_path__ + "static/textbook_cover-3b1cb542d5df9e3c4af503b34dfb588d.jpg";